// src/components/Navbar.jsx

 

import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";

import './components.css'; // Ensure to import the CSS file for styles

// src/components/Footer.jsx

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <a href="https://www.nhs.uk/accessibility-statement/" className="footer-link"> Accessibility </a>
                <a href="/terms" className="footer-link"> Terms of Use </a>
                <span className="footer-pathway"> PATHWAY </span>
                <a href="https://www.nhsinform.scot/privacy-and-cookies-policy/" className="footer-link"> Privacy Policy </a>
                <a href="https://www.nhs.uk/nhs-app/nhs-app-help-and-support/" className="footer-link"> Help and Support </a>
            </div>
        </footer>
    );
};

export default Footer;
